// Ported from document-ready 2.0.1 and scroll-to-anchor 1.0.0 (MIT)
// https://github.com/bendrucker/document-ready — https://github.com/yoshuawuyts/scroll-to-anchor

import { notEqual } from './assert.js'

export function documentReady (callback) {
  notEqual(typeof document, 'undefined', 'documentReady only runs in the browser')
  const state = document.readyState
  if (state === 'complete' || state === 'interactive') {
    return setTimeout(callback, 0)
  }

  document.addEventListener('DOMContentLoaded', function onLoad () {
    callback()
  })
}

export function scrollToAnchor (anchor) {
  if (anchor) {
    try {
      const el = document.querySelector(anchor)
      if (el) el.scrollIntoView(true)
    } catch (e) {}
  }
}
